import React from "react";
import AdminContainer from "../Administraton.container";
import AppPermission from "../components/ApplicationPermission/ApplicationPermission-container";
import AppOnboarding from "../components/Apponboarding";
import AppRoles from "../components/AppRoles";
import UserManagement from "../components/UserManagment";

export interface routeType {
    path: string;
    component: any;
}

const AdminRoutes: Array<routeType> = [
    {
        path:'/',
        component: AdminContainer
    },
    {
        path:'/usermanagement',
        component: UserManagement
    },
    {
        path:'/apponboarding',
        component:AppOnboarding
    },
    {
        path:'/applicationpermission',
        component:AppPermission
    },
    {
        path:'/roles',
        component:AppRoles
    }
]

export default AdminRoutes;
